import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { environment } from 'apps/landing/src/environments/environment';
import { ActivatedRoute, UrlSegment, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs';
import { Router, NavigationStart } from '@angular/router';
import { animate, query, stagger, style, transition, trigger } from '@angular/animations';

// import { examData } from '../../../ng1/www/modules/exam/services';

@Component({
  selector: 'polylearn-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: [
    trigger('listAnimation', [
      transition('* => *', [ // each time the binding value changes
        query(':enter', [
          style({ opacity: 0 }),
          stagger(100, [
            animate('0.5s', style({ opacity: 1 }))
          ])
        ], { optional: true })
      ])
    ])
  ]
})
export class HeaderComponent implements OnInit {
  exam = environment.EXAM;
  examData = null; // examData[this.exam];
  isIndex = true;
  isLogin = true;
  isMobileMenuOpened: boolean;

  announcement = (environment as any)?.index?.announcement;

  links = (environment as any)?.navbar.filter(function(link) {
    return !!link.show;
  });

  displayLinks;

  actionsLinks;
  url$: Observable<any>;

  constructor(
    private router: Router,
  ) { }

  _subscription;
  ngOnInit(): void {
    this._isIndex();
    this._isLogin();

    this._subscription = this.router.events.subscribe(event => {
      if(event instanceof NavigationEnd) {
        this._isIndex();
        this._isLogin();
      }
    });

    this.actionsLinks = this.links.filter(l => l.action)
    this.displayLinks = this.links.filter(l => !l.action)
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
  }

  private _isIndex() {
    this.isIndex = this.router.url === '/';
  }

  _loginUrls = ['/activation', '/register', '/login'];
  private _isLogin() {
    this.isLogin = this._loginUrls.includes(this.router.url);
    console.log('isLogin', this.isLogin);
  }

}
